import { ProgressBar } from 'primereact/progressbar';

const Spinner = () => {   
    return (
        <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
    );
}


export default Spinner;